export default __webpack_public_path__ + "static/media/hospital.2efd319a.webp";